module.exports = __webpack_public_path__ + "static/media/ni.3f7681e7.svg";